function Logout() {
  localStorage.clear();
  window.location.replace("http://www.aganhealthcare.com");
}
export default Logout;
